import { useEffect, useRef, useState } from "react";
import scrumMasterImage from "../../assets/images/scrummaster.png";
import helpDeskImage from "../../assets/images/helpdesk.jpg";
import kpiImage from "../../assets/images/kpi.png";
import orgChartImage from "../../assets/images/orgchart.jpg";

import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import AppConstants from "../../common/AppConstants";
import CommonMethods from "../../common/CommonMethods";

function ProductsList() {
  const swiperProducts = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
  };

  const handleMouseEnter = () => {
    (swiperProducts?.current as any).swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    (swiperProducts?.current as any).swiper?.autoplay?.start();
  };

  return (
    <>
      <section className="product-wrap">
        <div id="products" className="container">
          <div className="row align-items-center text-center">
            <div className="col-12 serv-header-three">
              <h4>Know more about</h4>
              <h2>Our Products</h2>
              <p>
                for the business of all natures, sizes, countries and regions
              </p>
            </div>
            <div className="col">
              <div
                className="slider-container "
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onBlur={handleMouseLeave}
              >
                <Swiper
                  ref={swiperProducts}
                  // install Swiper modules
                  modules={[Navigation, Pagination, A11y, Autoplay]}
                  spaceBetween={50}
                  slidesPerView={3}
                  mousewheel={true}
                  freeMode={true}
                  // freeModeMomentum={false}
                  allowTouchMove={true}
                  loop={true}
                  autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                  }}
                  speed={2000}
                  breakpoints={{
                    100: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    1000: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}
                  // navigation
                  // pagination={{ clickable: true }}
                  // scrollbar={{ draggable: true }}
                  // onSwiper={(swiper: any) => console.log(swiper)}
                  // onSlideChange={() => console.log("slide change")}
                >
                  <SwiperSlide>
                    <div className="prod-item-wrapper">
                      <div className="prod-item">
                        <a
                          href={CommonMethods.getRouteLink(
                            AppConstants.Views.Products.ScrumMaster
                          )}
                          className="prod-href"
                        >
                          <div className="prod-header">
                            <span>
                              <img
                                style={{ width: "45px" }}
                                src="https://store-images.s-microsoft.com/image/apps.4448.ce3edb79-5629-48ca-8c0b-12eb25ebbf88.39c27f79-dc81-4014-952c-5c1f441dfcb4.2c4f0921-72c1-4c53-bd6d-f0d09186343f.png"
                                alt=""
                              />
                            </span>
                            <h2>Scrum Master</h2>
                          </div>
                          <div className="prod-img">
                            {/* <img src={scrumMasterImage} alt="" /> */}
                          </div>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="prod-item-wrapper">
                      <div className="prod-item">
                        <a
                          href={CommonMethods.getRouteLink(
                            AppConstants.Views.Products.HelpDesk
                          )}
                          className="prod-href"
                        >
                          <div className="prod-header">
                            <span>
                              <img
                                style={{ width: "45px" }}
                                src="https://store-images.s-microsoft.com/image/apps.37319.9489ec48-5663-40f9-9a68-30bd3a7f6aa9.c020cd6b-0d69-4765-a1ac-26ca7ce814da.af5ca0c5-a528-4258-83fe-cf3cbca96820.png"
                                alt=""
                              />
                            </span>
                            <h2>HelpDesk Portal</h2>
                          </div>
                          <div className="prod-img">
                            {/* <img src={helpDeskImage} alt="" /> */}
                          </div>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="prod-item-wrapper">
                      <div className="prod-item">
                        <a
                          href={CommonMethods.getRouteLink(
                            AppConstants.Views.Products.KPI
                          )}
                          className="prod-href"
                        >
                          <div className="prod-header">
                            <span>
                              <img
                                style={{ width: "45px" }}
                                src="https://store-images.s-microsoft.com/image/apps.4448.ce3edb79-5629-48ca-8c0b-12eb25ebbf88.39c27f79-dc81-4014-952c-5c1f441dfcb4.2c4f0921-72c1-4c53-bd6d-f0d09186343f.png"
                                alt=""
                              />
                            </span>
                            <h2>KPI And Analytics</h2>
                          </div>
                          <div className="prod-img">
                            {/* <img src={kpiImage} alt="" /> */}
                          </div>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="prod-item-wrapper">
                      <div className="prod-item">
                        <a
                          href={CommonMethods.getRouteLink(
                            AppConstants.Views.Products.Directory
                          )}
                          className="prod-href"
                        >
                          <div className="prod-header">
                            <span>
                              <img
                                style={{ width: "45px" }}
                                src={
                                  "https://store-images.s-microsoft.com/image/apps.31926.3b416db1-31df-4f6c-8a20-80da005b041d.37da6747-967f-4527-9dbb-d8f8464afc7d.f519137e-bad2-4d22-b7b7-506c1ab018ae.png"
                                }
                                alt=""
                              />
                            </span>
                            <h2>Employee Directory & Org Chart</h2>
                          </div>
                          <div className="prod-img">
                            {/* <img src={orgChartImage} alt="" /> */}
                          </div>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductsList;
